import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/outer',
    alias: '/',
    name: 'outer',
    component: () => import('../Outer.vue'),
    children: [
      {
        path: '/',
        name: 'main-page',
        component: () => import('../views/Main-page.vue')
      },
      {
        path: '/my-book-page',
        name: 'my-book-page',
        component: () => import('../views/My-book-page.vue')
      },
      {
        path: '/book-volumes-list',
        name: 'book-volumes-list',
        component: () => import('../views/book-volumes-list.vue')
      },
      {
        path: '/book-volume-item',
        name: 'book-volume-item',
        component: () => import('../views/book-volume-item.vue')
      },
      {
        path: '/book-list',
        name: 'book-list',
        component: () => import('../views/Book-list.vue')
      },
      {
        path: '/audio-play',
        name: 'audio-play',
        component: () => import('../views/audio-play.vue')
      },
      {
        path: '/user-agreement',
        name: 'user-agreement',
        meta: {title: '用户协议'},
        component: () => import('../views/user-agreement.vue')
      }
    ]
  },
  {
    path: '/inner',
    name: 'inner',
    component: () => import('../Inner.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {title: '攀登分级阅读'},
        component: () => import('../views/Home.vue')
      },
      {
        path: '/book-video',
        name: 'book-video',
        meta: {title: '看动画'},
        component: () => import('../views/BookVideo.vue')
      },
      {
        path: '/read',
        name: 'read',
        meta: {title: '读一读'},
        component: () => import('../views/Read.vue')
      },
      {
        path: '/read-new',
        name: 'read-new',
        meta: {title: '读一读'},
        component: () => import('../views/ReadNew.vue')
      },
      {
        path: '/follow-read',
        name: 'follow-read',
        meta: {title: '跟着读'},
        component: () => import('../views/FollowRead.vue')
      },
      {
        path: '/follow-read-new',
        name: 'follow-read-new',
        meta: {title: '跟着读'},
        component: () => import('../views/FollowReadNew.vue')
      },
      {
        path: '/exercise',
        name: 'exercise',
        meta: {title: '练一练'},
        component: () => import('../views/Exercise.vue')
      },
      {
        path: '/dub',
        name: 'dub',
        meta: {title: '趣配音'},
        component: () => import('../views/Dub.vue')
      },
      {
        path: '/dub-work',
        name: 'dub-work',
        meta: {title: '趣配音'},
        component: () => import('../views/DubWork.vue')
      },
      {
        path: '/skip',
        name: 'skip',
        meta: {title: '跳转中'},
        component: () => import('../views/Skip.vue')
      },
      {
        path: '/test',
        name: 'test',
        meta: {title: '测试'},
        component: () => import('../views/Test.vue')
      }
    ]
  },

]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta && to.meta.title) ? to.meta.title : '攀登分级阅读'
  next()
})

export default router
